<template>
  <div>
    <div class="black-overlay"></div>

    <div class="modal modal--welcomeback " id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>

        <div class="modal__header">
          <h1>{{ getTranslations[title] }}</h1>

          <img class="usericon" :src="icon" alt="">
        </div>

        <div class="modal__body">
          <p class="modal_strong">{{ getTranslations[description] }}</p>

          <p v-if="getTranslations[descriptionPoints]">{{ getTranslations[descriptionPoints] }}</p>
        </div>

        <div class="modal__footer">
          <a
            href="#"
            class="btn2 btn2--std btn2--small btn2--fixed"
            @click.prevent="$emit('proceed')"
          >
            {{ getTranslations.modal_penalty_post_game_button_proceed }}
          </a>
        </div>
      </div>
    </div>

    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'PostPenaltyGame',
  emits: ['proceed'],
  created () {
    const payload = {
      gameId: this.addOnGameData.gameId,
      successful: this.addOnGameData.success,
      correctAnswers: this.addOnGameData.correctAnswers,
      adjustPenaltyPoints: 'true',
    };

    this.updateDGamesForAddOn(payload);
  },
  computed: {
    ...mapState('game', [
      'addOnGameData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    title () {
      return this.addOnGameData.success ? 'modal_penalty_post_game_title_won' : 'modal_penalty_post_game_title_lost';
    },
    description () {
      return this.addOnGameData.success ? 'modal_penalty_post_game_description_won' : 'modal_penalty_post_game_description_lost';
    },
    descriptionPoints () {
      return this.addOnGameData.success ? 'modal_penalty_post_game_description_points_won' : 'modal_penalty_post_game_description_points_lost';
    },
    icon () {
      return this.addOnGameData.success ? 'static/images/face_won.png' : 'static/images/face_lost.png';
    },
  },
  methods: {
    ...mapActions('profile', [
      'updateDGamesForAddOn',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PostPenaltyGame.vue